import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import Type from '../Typography';
import { SmallContext } from '../utils';

import styles from './Radio.less';

const DEFAULT = void 0;
const cxb = cx.bind(styles);

/**
 * **Access:**
 * ```js
 * import { Radio } from '@iss/client-react-components'
 * ```
 *
 * A styled controlled radio button.
 *
 * Note: The statfull "uncontrolled" style of usage is not supported with this component. It
 * requires the consumer to manage the value.
 *
 */
export default class Radio extends React.Component {
  static contextType = SmallContext;

  static propTypes = {
    /** The Radio Group Identifier */
    name: PropTypes.string,
    /** Text to go beside the control */
    label: PropTypes.string,
    /** The selectied state. On or Off (true/false)*/
    checked: PropTypes.bool,
    /** The control is over a dark background? Yes/No (true/false) */
    dark: PropTypes.bool,
    /** Use small layout */
    small: PropTypes.bool,
  };

  get small() {
    return SmallContext.isSmall(this);
  }

  render() {
    const {
      small,
      props: { children, className, dark, label, ...props },
    } = this;
    const { disabled, checked } = props;
    const hasChildren = React.Children.toArray(children).filter(Boolean).length > 0;
    const Container = hasChildren ? 'div' : React.Fragment;
    const containerProps = hasChildren ? { className } : {};

    return (
      <Container {...containerProps}>
        <label
          className={cx(cxb('root', { dark, disabled, small }), { [className]: className && !hasChildren })}
          tabIndex={disabled ? null : '0'}
        >
          <input {...props} type="radio" />
          <svg className={cxb({ glyph: true, checked })} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <g>
              <circle cx="10" cy="10" r="10" />
              <circle cx="10" cy="10" r="9" />
            </g>
            {checked && <circle cx="10" cy="10" r="6" />}
          </svg>
          {label && (
            <Type face={small ? 'small' : DEFAULT} className={cxb('label')}>
              {label}
            </Type>
          )}
        </label>

        {hasChildren && checked && <div className={cxb('sub')}>{children}</div>}
      </Container>
    );
  }
}
